module.exports = ".form-button {\n    margin-top: 20px;\n}\n\n.btn-size {\n    width: 120%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/artefato/servico/servico.component.css
// module id = ./src/app/artefato/servico/servico.component.css
// module chunks = main